module.exports = __webpack_public_path__ + "static/media/4.d2be76ed.png";